<template>
  <div v-if="open" class="faq-modal">
    <div class="faq-modal__backdrop" @click="$emit('close')"></div>
    <div class="faq-modal__box">
      <div class="faq-modal__header">
        <h3>Reglamentación y preguntas frecuentes</h3>
        <button type="button" class="faq-modal__close" @click="$emit('close')" aria-label="Cerrar">✕</button>
      </div>
      <div class="faq-modal__body">
        <div class="faq-modal__card">
          <h3>Enfoque de la Olimpiada</h3>
          <ul class="faq-modal__bullets">
            <li>Pueden participar estudiantes de todas las edades menores de 18 años.</li>
            <li>El concurso no tiene límite mínimo de edad, 
              el contenido está dirigido principalmente a estudiantes que están en los grados superiores 9, 10 y 11. 
              En versiones anteriores han participado estudiantes que aunque muy jóvenes tienen desempeños altos por lo que la sugerencia es que todos los estudiantes de 9 , 10 y 11 participen y estudiantes sobresalientes de grados menores también pueden ser incentivados a participar.
              </li>
             <li>Para los estudiantes más jóvenes, la olimpiada representa una excelente oportunidad de entrenamiento y preparación para futuras ediciones.</li>
          </ul>
        </div>


        <div class="faq-modal__card">
          <h3>¿Requisitos para participar?</h3>
          <ul class="faq-modal__bullets">
            <li>El único requisito para participar en la olimpiada es tener menos de 18 años al 24 de mayo de 2026. Es decir, si cumples 18 antes de esa fecha no puedes participar.</li>
          </ul>
        </div>

        <div class="faq-modal__card">
          <h3>¿Qué países participan?</h3>
          <ul class="faq-modal__bullets">
            <li>Puedes participar desde cualquier parte del mundo.</li>
          </ul>
        </div>

        <div class="faq-modal__card">
          <h3>Fases de la Olimpiada y funcionamiento</h3>
          <p class="faq-modal__lead">La olimpiada consta de dos fases, ambas 100 % virtuales y supervisadas por cámara. Es obligatorio contar con un dispositivo con cámara activa durante toda la prueba.</p>
          <h4>1. Fase Clasificatoria</h4>
          <ul class="faq-modal__bullets">
            <li><strong>📅 3 de mayo</strong> — 20 preguntas de matemáticas.</li>
            <li>Participan todos los estudiantes inscritos.</li>
            <li>Clasifica el 50 % con mejor puntaje a la Gran Final.</li>
            <li>Es obligatoria para todos los participantes.</li>
            <li>Se habilitarán múltiples sesiones y cada estudiante podrá elegir la que mejor se ajuste a su agenda.</li>
          </ul>
          <p><strong>Cómo ingresar:</strong> El día de la prueba, el estudiante debe:</p>
          <ul class="faq-modal__bullets">
            <li>Entrar a www.mobiusml.com</li>
            <li>Iniciar sesión con el correo registrado</li>
            <li>Ingresar al curso “Olimpiadas 2026”</li>
            <li>Hacer clic en el enlace “Fase Clasificatoria”</li>
          </ul>
          <h4>2. Gran Final</h4>
          <p><strong>📅 24 de mayo</strong></p>
          <p>La Gran Final consta de dos exámenes el mismo día:</p>
          <ul class="faq-modal__bullets">
            <li><strong>Primer examen general:</strong> 20 preguntas de conocimiento matemático general. Los 20 mejores puntajes avanzan al segundo examen.</li>
            <li><strong>Segundo examen (final):</strong> Define los 3 primeros lugares de la olimpiada.</li>
          </ul>
          <p><strong>Funcionamiento:</strong></p>
          <ul class="faq-modal__bullets">
            <li>Cada estudiante clasificado ingresará al enlace de la sesión que haya elegido para conectarse a una llamada de Google Meet, donde el equipo de Mobius supervisará la prueba.</li>
            <li>Es obligatorio conectarse a la llamada.</li>
            <li>Dentro de la plataforma se habilitará el módulo “Examen Final”.</li>
            <li>Duración del examen: 1 hora.</li>
            <li>Desde el 4 de mayo, la plataforma contará con recursos de práctica específicos para esta fase.</li>
          </ul>
        </div>

        <div class="faq-modal__card">
          <h3>Verificación de identidad</h3>
          <p>Durante cualquiera de las fases, el estudiante debe tener a la mano un documento de identificación que permita verificar que cumple con el requisito de edad.</p>
        </div>

        <div class="faq-modal__card">
          <h3>Sistema de puntaje y desempate</h3>
          <p>La clasificación se realiza mediante un sistema de puntos:</p>
          <ul class="faq-modal__bullets">
            <li>Dificultad alta: 3 puntos</li>
            <li>Dificultad media: 2 puntos</li>
            <li>Dificultad baja: 1 punto</li>
          </ul>
          <p>Los estudiantes se ordenan según el puntaje total. En caso de empate:</p>
          <ul class="faq-modal__bullets">
            <li>Se toma como criterio el tiempo total de finalización del examen.</li>
            <li>Si el empate persiste, los estudiantes compartirán la misma posición y cualquier premio asociado se dividirá equitativamente.</li>
          </ul>
        </div>

        <div class="faq-modal__card">
          <h3>Nivel de dificultad</h3>
          <p>Cada ejercicio muestra su nivel de dificultad en la parte derecha de la pantalla. Este nivel es definido previamente por profesores expertos en matemáticas.</p>
        </div>

        <div class="faq-modal__card">
          <h3>Entrega de premios</h3>
          <p>Por seguridad de los ganadores, los premios se entregan mediante transferencia bancaria a la cuenta de preferencia del estudiante ganador. El procedimiento específico depende del país de residencia.</p>
        </div>

        <div class="faq-modal__card">
          <h3>¿Cómo puedo prepararme para la olimpiada?</h3>
          <p>Desde febrero de 2026 estará disponible el curso Olimpiadas Mobius 2026, que incluye lecciones, prácticas y simulacros. Se recomienda entrenar todos los días al menos 30 minutos.</p>
        </div>

        <div class="faq-modal__card">
          <h3>Declaración de honor</h3>
          <p>Todas las fases se realizan de forma virtual. El estudiante se compromete, bajo su honor, a realizar las pruebas de manera individual y sin ayuda externa, ya sea de personas o recursos digitales.</p>
          <p>Cualquier incumplimiento comprobado será sancionado con:</p>
          <ul class="faq-modal__bullets">
            <li>Expulsión inmediata de la Olimpiada Mobius</li>
            <li>Anulación de cualquier premio obtenido</li>
          </ul>
          <p>Hacer trampa en la fase clasificatoria no tiene sentido: un estudiante que lo haga tendrá un bajo desempeño en la fase final y solo estará quitando oportunidades a quienes sí las merecen.</p>
        </div>
      </div>
      <div class="faq-modal__footer">
        <button type="button" class="mob-btn mob-cta-gold" @click="$emit('close')">
          Entendido
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OlimpiadasFaqModal",
  props: { open: Boolean },
  emits: ["close"],
};
</script>

<style scoped>
/* Same positioning as Terms modal: lower so header doesn't cover */
.faq-modal {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 72px;
  padding-bottom: 24px;
  box-sizing: border-box;
}
.faq-modal__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 18, 28, 0.6);
}
/* Same box style as Terms modal */
.faq-modal__box {
  position: relative;
  z-index: 1;
  width: min(760px, 92vw);
  max-height: 90vh;
  background: #ffffff;
  border-radius: 18px;
  padding: 24px;
  box-shadow: 0 24px 48px rgba(23, 30, 52, 0.2);
  display: flex;
  flex-direction: column;
}
.faq-modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-shrink: 0;
}
.faq-modal__header h3 {
  font-size: 18px;
  font-weight: 700;
  color: #1d2433;
  margin: 0;
}
.faq-modal__close {
  border: none;
  background: #f2f3f7;
  border-radius: 10px;
  width: 32px;
  height: 32px;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}
.faq-modal__body {
  color: #1d2433;
  font-size: 14px;
  line-height: 1.55;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  padding-right: 4px;
}
.faq-modal__card {
  background: #f8f9fc;
  border-radius: 12px;
  padding: 16px 18px;
  margin-bottom: 14px;
  border: 1px solid #e5e7eb;
}
.faq-modal__card:last-child {
  margin-bottom: 0;
}
.faq-modal__card h3 {
  font-size: 15px;
  font-weight: 700;
  color: #1d2433;
  margin: 0 0 10px 0;
}
.faq-modal__card h4 {
  font-size: 15px;
  font-weight: 700;
  color: #1d2433;
  margin: 20px 0 10px 0;
}
.faq-modal__card h4:first-of-type {
  margin-top: 8px;
}
.faq-modal__card p {
  margin: 0 0 10px 0;
  color: #1d2433;
}
.faq-modal__lead {
  margin-bottom: 12px !important;
}
.faq-modal__bullets {
  list-style: disc;
  padding-left: 20px;
  margin: 8px 0 12px 0;
  color: #1d2433;
}
.faq-modal__bullets li {
  margin-bottom: 6px;
}
.faq-modal__footer {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}
</style>
